import { ApiSlugs, ListPagination, TicketId, TicketSummaryDto } from '@workspace/data-types';
import { Observable } from 'rxjs';
import { ApiCaller } from '../../../../../api-caller.service';
import { ApiConnector } from '../../../../../api-connector.abstract-service';
import { QueryParamsUtils } from '../../../../../utils/query-params.utils';

export class UserTicketsAdminConnector extends ApiConnector<TicketSummaryDto, TicketSummaryDto, TicketId> {
  constructor(apiCaller: ApiCaller, userUrl: string, apiPrefix: string) {
    super(apiCaller, apiPrefix, `${userUrl}/${ApiSlugs.TICKETS}`);
  }

  summerized = () => ({
    list: (pagination?: ListPagination): Observable<TicketSummaryDto[]> =>
      this.apiCaller.getRequest<TicketSummaryDto[]>(
        this.apiPrefix,
        `${this.slug}/all${QueryParamsUtils.buildFilterParams(pagination)}`,
      ),
    count: (pagination?: ListPagination): Observable<number> =>
      this.apiCaller.getRequest<number>(
        this.apiPrefix,
        `${this.slug}/all/count${QueryParamsUtils.buildFilterParams(pagination, true)}`,
      ),
  });
}
